module.exports = __webpack_public_path__ + "img/40_38_023_020.c8388a91.jpg";